import { render, staticRenderFns } from "./succes.vue?vue&type=template&id=6d801ea9&scoped=true"
import script from "./succes.vue?vue&type=script&lang=ts"
export * from "./succes.vue?vue&type=script&lang=ts"
import style0 from "./succes.vue?vue&type=style&index=0&id=6d801ea9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d801ea9",
  null
  
)

export default component.exports